module.exports = "<div class=\"main-content-video main-content-video--full\">\r\n    <a class=\"content-video js-video-popup\" href=\"<%-item.videoId ? item.videoId : item.video %>\" data-player=\"youtube\" style=\"background-image: url('<%-item.poster%>')\">\r\n        <div class=\"caption\">\r\n            <span class=\"caption__text\"><%-item.title%></span>\r\n            <span class=\"video-play-icon\"><svg class=\"icon\"><use xlink:href=\"#spr-play-icon\"></use></svg></span>\r\n        </div>\r\n    </a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./js/components/Gallery/GalleryItemVideo.ejs
// module id = 229
// module chunks = 0